import { Button } from '@cian/ui-kit';
import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

interface ILocationSubscriptionProps {
  onClick: () => void;
}

export const LocationSubscription = ({ onClick }: ILocationSubscriptionProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <ArticleHeading4>Подпишитесь на объявления в этой локации</ArticleHeading4>
        <div className={styles['description']}>
          <ArticleParagraph1>Мы сообщим, как только поблизости появится что‑нибудь новенькое</ArticleParagraph1>
        </div>
        <Button theme="fill_primary" size="XS" onClick={onClick}>
          Подписаться
        </Button>
      </div>
    </div>
  );
};
